import { useHistory } from 'react-router-dom';
import React, { useEffect } from 'react';
import { SessionManager, SessionType } from '../session-manager';
import { env_vars } from '../../load-env';
import { OidcSession } from './oidc-session';


export const LoginCallbackPage: React.FC = () => {
    const history = useHistory();

    useEffect(() => {
        const handleSignin = async () => {
            try {
                const session = await SessionManager.createSession(SessionType.OIDC);

                const oidcSession = session as unknown as OidcSession;

                await oidcSession.userManager.signinRedirectCallback();

                await session.start();

                history.replace('/');
            } catch (e) {
                console.error('Something went wrong during signin.', e);
                window.location.replace(env_vars.OIDC_POST_LOGOUT_REDIRECT_URI!);
            }
        };

        handleSignin();
    }, [history]);

    return null;
};


export const OidcSilentRenewPage: React.FC = () => {
    const history = useHistory();

    useEffect(() => {
        const silentRenew = async () => {
            try {
                const session = await SessionManager.createSession(SessionType.OIDC);
                const oidcSession = session as unknown as OidcSession;

                await oidcSession.userManager.signinSilentCallback();
            } catch (e) {
                console.error('Something went wrong during silent renew.', e);
            }
        };

        silentRenew();
    }, [history]);

    return null;
};
